import type { FC } from "react";
import { View } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import "../../../theme";
import { Text } from "../../Text";

export interface SearchEmptyProps {
  readonly message?: string | undefined;
}

const SearchEmpty: FC<SearchEmptyProps> = ({ message = "No results" }) => {
  return (
    <View style={styles.emptyContainer}>
      <Text textStyle="sm/regular" color="textMuted">
        {message}
      </Text>
    </View>
  );
};

SearchEmpty.displayName = "SearchEmpty";

export { SearchEmpty };

const styles = StyleSheet.create((theme) => ({
  emptyContainer: {
    paddingVertical: theme.spacing["5xl"],
    paddingHorizontal: theme.spacing["3xl"],
    alignItems: "center",
  },
}));
